import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { StylesProvider, ThemeProvider, CssBaseline } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { LicenseInfo } from '@mui/x-data-grid-pro';
import DateFnsUtils from '@date-io/date-fns';

import {
  guestServicesTheme,
  ScrollToTop,
  useGoogleTagManager,
  TagManagerContext,
  useCurrentCustomerCode,
} from '@lib/common';
import { AppRoutes } from './shared/app.routes';
import { ResourceLoader } from './resource-loader';
import { QueryClientProvider } from 'react-query';
import { queryClient } from '@lib/state';

LicenseInfo.setLicenseKey(
  'e7882171da3d93d4f8dfa9e3685724cdT1JERVI6MzQ0NzUsRVhQSVJZPTE2NzEyOTU1NDYwMDAsS0VZVkVSU0lPTj0x'
);

export const App = () => (
  <AppProviders>
    <AppRoutes />
  </AppProviders>
);

export const AppProviders: React.FC = ({ children }) => {
  useGoogleTagManager();
  const customerCode = useCurrentCustomerCode('armadillo');

  return (
    <StylesProvider injectFirst>
      <ThemeProvider theme={guestServicesTheme}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <TagManagerContext.Provider value={{ initialized: true }}>
            <ResourceLoader customerCode={customerCode}>
              <QueryClientProvider client={queryClient}>
                <CssBaseline />
                <Router>
                  <ScrollToTop />
                  {children}
                </Router>
              </QueryClientProvider>
            </ResourceLoader>
          </TagManagerContext.Provider>
        </MuiPickersUtilsProvider>
      </ThemeProvider>
    </StylesProvider>
  );
};
